import { Reports } from "pages/Reports";
import { REPORT_COLUMN_PRESETS } from "reducers/const";

const FuelAdvanced = () => {
	return <Reports primaryDataType='fuel' initialPreset={REPORT_COLUMN_PRESETS.GOLDEN_10} />;
};

export default FuelAdvanced;
